import { keyframes, styled } from "styled-components";

export const HomeWrapper = styled.div``;

const scrollArrow = keyframes`
  0% {
    transform: translateY(-50%);
    opacity: 1;
  }
  50% {
    transform: translateY(0);
    opacity: 0.5;
  }
  100% {
    transform: translateY(-50%);
    opacity: 1;
  }
`;

export const MainVideoContainer = styled.div`
  position: relative;
  video {
    width: 100%;
  }
  .arrow-wrap {
    width: 48px;
    height: 26px;
    position: absolute;
    bottom: 30px;
    left: 50%;
    transform: translateY(-50%);
    margin-left: -24px;
    display: block;
    animation: ${scrollArrow} infinite 1.8s linear;
  }
`;

export const HomeMainVisualWrapper = styled.div`
  padding: 120px 0;
  border-bottom: 1px solid #dfdfdf;
  background-color: #f7f7f7;
  @media all and (max-width: 1024px) {
    padding: 100px 0;
  }
  @media all and (max-width: 768px) {
    padding: 10.417vw 0;
  }
`;

export const HomeMainVisualContainer = styled.div`
  display: flex;
  align-items: center;
  gap; 40px;
  justify-content: space-between;  
  @media all and (max-width: 768px) {
    gap: 5.208vw;
    flex-direction: column;
  }
`;

export const HomeMainVisualLogoWrap = styled.div`
  padding: 0 70px;
  img {
    width: 380px;
    height: 65px;
  }
  @media all and (max-width: 1024px) {
    padding: 0 50px;
    img {
      width: 280px;
      height: 48px;
    }
  }
  @media all and (max-width: 768px) {
    padding: 0 6.51vw;
    img {
      width: 41.667vw;
      height: 7.161vw;
    }
  }
`;

export const HomeMainVisualTextWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  h6 {
    font-weight: bold;
    color: #242424;
    font-size: 24px;
    line-height: 1.5;
  }
  p {
    color: #242424;
    font-size: 20px;
    line-height: 1.4;
  }
  @media all and (max-width: 1024px) {
    gap: 12px;
    h6 {
      font-size: 18px;
    }
    p {
      font-size: 16px;
    }
  }
  @media all and (max-width: 768px) {
    gap: 3.906vw;
    h6 {
      font-size: 3.385vw;
      text-align: center;
    }
    p {
      font-size: 3.125vw;
      text-align: center;
    }
  }
`;

export const HomeMainContentWrapper = styled.div`
  padding: 80px 0;
  @media all and (max-width: 1024px) {
    padding: 60px 0;
  }
  @media all and (max-width: 768px) {
    padding: 7.813vw 0;
  }
`;

export const HomeMainContentWrap = styled.div`
  display: flex;
  gap: 20px;
  .main-list {
    display: flex;
    align-items: center;
    gap: 20px;
    li {
      > a {
        display: flex;
        flex-direction: column;
        gap: 16px;
        color: #171717;
        > i {
          display: block;
          width: 380px;
          height: 400px;
          img {
            display: block;
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .info-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        gap: 24px;
        > div {
          display: flex;
          flex-direction: column;
          gap: 4px;
        }
        h6 {
          font-family: "AnekLatin-semibold";
          font-weight: 600;
          font-size: 36px;
        }
        p {
          color: #6f6f6f;
          font-weight: 700;
          font-size: 24px;
          line-height: 1.3;
        }
        > i {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 72px;
          height: 48px;
          border: 1px solid #171717;
          border-radius: 30px;
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
    }
  }
  .introduce-list {
    display: flex;
    flex-direction: column;
    gap: 20px;
    width: 100%;
    li {
      height: calc(50% - 10px);
      width: 100%;

      > a {
        display: flex;
        padding: 24px;
        justify-content: space-between;

        height: 100%;
        > i {
          display: flex;
          align-items: center;
          justify-content: center;
          width: 72px;
          height: 48px;
          border: 1px solid #171717;
          border-radius: 30px;
          img {
            width: 40px;
            height: 40px;
          }
        }
      }
      .text-wrap {
        h6 {
          font-family: "AnekLatin-semibold";
          font-weight: 600;
          font-size: 36px;
        }
        p {
          font-weight: 700;
          font-size: 24px;
          line-height: 1.3;
        }
      }
      &:first-child {
        background-color: #171717;
        > a {
          i {
            border: 1px solid #ffffff;
          }
        }
        h6 {
          color: #fbfbfb;
        }
        p {
          color: #c1c1c1;
        }
      }
      &:nth-child(2) {
        border: 1px solid #171717;
        h6 {
          color: #171717;
        }
        p {
          color: #6f6f6f;
        }
      }
    }
  }
  @media all and (max-width: 1200px) {
    .main-list {
      gap: 16px;
      li {
        > a {
          gap: 12px;
          > i {
            width: 280px;
            height: 330px;
          }
        }

        .info-wrap {
          gap: 18px;
          > div {
            gap: 2px;
          }
          h6 {
            font-size: 30px;
          }
          p {
            font-size: 20px;
          }
          > i {
            width: 60px;
            height: 42px;
            img {
              width: 30px;
              height: 30px;
            }
          }
        }
      }
    }
    .introduce-list {
      gap: 16px;
      li {
        height: calc(50% - 8px);

        > a {
          padding: 18px;

          > i {
            width: 60px;
            height: 42px;
            img {
              width: 30px;
              height: 30px;
            }
          }
        }
        .text-wrap {
          h6 {
            font-size: 30px;
          }
          p {
            font-size: 20px;
          }
        }
      }
    }
  }
  @media all and (max-width: 900px) {
    flex-direction: column;
    .main-list {
      width: 100%;
      gap: 20px;
      li {
        width: calc(50% - 10px);
        > a {
          > i {
            width: 100%;
            height: 48.889vw;
          }
        }
      }
    }
    .introduce-list {
      flex-direction: row;
      gap: 20px;
      li {
        a {
          min-height: 130px;
        }
      }
    }
  }
  @media all and (max-width: 640px) {
    .main-list {
      flex-direction: column;
      gap: 3.125vw;
      li {
        width: 100%;
        > a {
          gap: 2.083w;
          > i {
            height: 80.917vw;
          }
        }
        .info-wrap {
          gap: 2.865vw;
          > div {
            gap: 0.521vw;
          }
          h6 {
            font-size: 4.948vw;
          }
          p {
            font-size: 3.906vw;
          }
          > i {
            width: 11.719vw;
            height: 7.031vw;
            img {
              width: 5.208vw;
              height: 5.208vw;
            }
          }
        }
      }
    }
    .introduce-list {
      flex-direction: column;
      gap: 3.125vw;
      li {
        .text-wrap {
          h6 {
            font-size: 4.948vw;
          }
          p {
            font-size: 3.906vw;
          }
        }
        > a {
          min-height: 28.646vw;
          > i {
            > i {
              width: 11.719vw;
              height: 7.031vw;
              img {
                width: 5.208vw;
                height: 5.208vw;
              }
            }
          }
        }
      }
    }
  }
`;

export const HomeBannerWrap = styled.div`
  width: 100%;
  padding: 40px 0;
  display: flex;
  align-items: center;
  gap: 40px;
  justify-content: center;
  background-color: #171717;
  h6 {
    color: #c1c1c1;
    font-weight: bold;
    font-size: 24px;
    line-height: 1.4;
  }
  p {
    font-size: 24px;
    line-height: 1.4;
    font-weight: bold;
    color: #fbfbfb;
  }
  @media all and (max-width: 900px) {
    padding: 35px 0;
    gap: 30px;
    h6 {
      font-size: 20px;
    }
    p {
      font-size: 20px;
    }
  }

  @media all and (max-width: 768px) {
    padding: 5.208vw 0;
    gap: 4.427vw;
    h6 {
      font-size: 3.906vw;
    }
    p {
      font-size: 3.906vw;
    }
  }
`;
